import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ExternalLink } from 'lucide-react';

const Footer: React.FC = () => {
  const year = new Date().getFullYear();

  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 10 },
    visible: { opacity: 1, y: 0 }
  };

  return (
    <footer className="bg-white dark:bg-gray-800 shadow-inner transition-colors duration-200">
      <motion.div 
        className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
        variants={containerVariants}
      >
        <div className="text-center space-y-4">
          <motion.div variants={itemVariants}>
            <p className="text-gray-600 dark:text-gray-300 transition-colors duration-200">
              © {year} E8 Software. All rights reserved.
            </p>
            <p className="text-sm text-gray-500 dark:text-gray-400 mt-2 transition-colors duration-200">
              <a 
                href="mailto:Support@e8software.com" 
                className="hover:text-blue-600 dark:hover:text-blue-400 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-white dark:focus:ring-offset-gray-800 rounded"
              >
                Support@e8software.com
              </a>
            </p>
            <address className="text-sm text-gray-500 dark:text-gray-400 mt-2 not-italic transition-colors duration-200">
              5830 E 2nd St, Ste 7000 #22471<br />
              Casper, WY 82609<br />
              US
            </address>
          </motion.div>

          <motion.div 
            variants={itemVariants}
            className="flex flex-col sm:flex-row justify-center sm:space-x-4 space-y-2 sm:space-y-0 text-sm"
          >
            <Link
              to="/terms"
              className="text-gray-500 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-white dark:focus:ring-offset-gray-800 rounded px-2 py-1"
            >
              Terms & Conditions
            </Link>
            <span className="hidden sm:inline text-gray-500 dark:text-gray-400">•</span>
            <Link
              to="/privacy"
              className="text-gray-500 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-white dark:focus:ring-offset-gray-800 rounded px-2 py-1"
            >
              Privacy Policy
            </Link>
          </motion.div>
        </div>
      </motion.div>
    </footer>
  );
};

// Memoize to prevent unnecessary re-renders
export default React.memo(Footer);